import { AUDIO_VIDEO_GROUPS } from "../../content/resources";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Section } from "../../ui/Section";

/**
 * The old site's `/audio---video`: the verbatim link set, grouped under the
 * three headings the old carousel used (YouTube, PodCast, Facebook).
 * English only - the old site had no Hindi rendering of this page.
 */
export function AudioVideoPage() {
  return (
    <Page title="Audio & Video" heading="Audio & Video">
      <Section>
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {AUDIO_VIDEO_GROUPS.map((group) => (
            <div key={group.heading}>
              <h2 className="eyebrow">{group.heading}</h2>
              <div className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <Button
                    key={link.href}
                    href={link.href}
                    external
                    variant="secondary"
                    className="w-full justify-start text-left"
                  >
                    {link.label}
                  </Button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Section>
    </Page>
  );
}
